import React from "react"
import { AspectRatio, Box, Container, Grid, Heading, HStack, Stack, StackDivider, Text } from "@chakra-ui/react"

import { useImage } from "@app/hooks/useImage"
import Image from "@app/components/Image/Image"

const ProductBenefits = ({ title, image, benefits }: GatsbyTypes.SanityProductBenefitSection) => {
  const { getGatsbyImage } = useImage()
  const resolvedImage = getGatsbyImage(image)

  const normalisedBenefits =
    benefits?.map(benefit => ({
      title: benefit?.title,
      description: benefit?.description,
      image: getGatsbyImage(benefit?.image),
    })) || []

  return (
    <Container py={5}>
      <Grid templateColumns={["unset", "repeat(2, 1fr)"]} gap={[2, 5]}>
        <AspectRatio ratio={[343 / 260, 54 / 47]} w="full">
          <Image {...resolvedImage} objectFit="cover" borderRadius={["none", "sm"]} />
        </AspectRatio>
        <Box>
          <Heading as="h2" size="h2" textAlign="center" mb={2}>
            {title}
          </Heading>
          <Stack spacing={2} divider={<StackDivider />}>
            {normalisedBenefits.map(benefit => (
              <HStack spacing={2} key={benefit.title}>
                <Image {...benefit.image} w="95px" h="95px" />
                <Box>
                  <Text size="lg" fontWeight="semibold">
                    {benefit.title}
                  </Text>
                  <Text size="sm">{benefit.description}</Text>
                </Box>
              </HStack>
            ))}
          </Stack>
        </Box>
      </Grid>
    </Container>
  )
}

export default ProductBenefits
